import React from "react";
import { Input } from "@sonder/ui/source/styled/fragments/Input";
import { InputField } from "@sonder/ui/source/styled/fragments/InputField";
import { Label } from "@sonder/ui/source/styled/fragments/Label";

interface LoginFieldProps {
  disabled?: boolean;
  error?: boolean | string | Error;
  label: string;
  name: string;
  type: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const LoginField = ({
  disabled,
  error,
  label,
  name,
  type,
  onChange,
}: LoginFieldProps) => (
  <InputField>
    <Label error={Boolean(error)}>{label}</Label>
    <Input
      autoComplete="off"
      disabled={disabled}
      error={Boolean(error)}
      name={name}
      type={type}
      onChange={onChange}
    />
  </InputField>
);
